module.exports = __webpack_public_path__ + "img/YP-Gold@4x.12056b55.png";